import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import Dashboard from "./components/Dashboard";
import SidebarMenu from "./components/SidebarMenu";
import ReportViewer from "./components/ReportViewer";
import ReportsList from "./components/ReportsList";
import "./styles/Dashboard.css";

const App = () => {
  const [selection, setSelection] = useState({
    platform: "",
    tests: [],
  });

    const [environment] = useState("india");  // default env

  return (
    <div className="app-container">
      {/* Sidebar */}
      <SidebarMenu setSelection={setSelection} />

      {/* Main Content */}
      <div className="main-content">

        {/* Routes */}
        <Routes>
          <Route
            path="/"
            element={
              <Dashboard
                selection={selection}
                environment={selection.platform === "Desk" ? environment : null}
              />
            }
          />
          <Route path="/report/:filename" element={<ReportViewer />} />
          <Route path="/reports" element={<ReportsList />} />
        </Routes>
      </div>
    </div>
  );
};

export default App;
